import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import styles from './LoadingView.scss';

const LoadingView = ({ isVisible = true, className }) => (
  <div className={cx(styles.container, className)}>
    <div className={isVisible ? styles.visible : styles.hidden}>
      <div className={styles.circle} />
    </div>
  </div>
);

LoadingView.propTypes = {
  className: PropTypes.string,
  isVisible: PropTypes.bool,
};

export default LoadingView;
